import { JackpotDisplayDiamondPotStep } from "./JackpotDisplayDiamondPotStep";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { Scale, Size } from "./MyHelpers";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocolScope } from "./ScreenProtocol";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";

export class JackpotDisplayCaliente extends JackpotDisplayDiamondPotStep {

	public constructor(params: JackpotDisplayParams) {
		super(params);
		this.logGroup.Add("JackpotDisplayCaliente");
		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayCaliente");

		this.resid = params.resid.Add("JackpotDisplayCaliente");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayCaliente");
		this.TitleContainer.style.height = Scale.Hpx(420);
	}

	
	public override TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStep/Sprites/calientetitle", this.resid.Add("title"), true, this.logGroup.Add("title"), true));		
	}
	
	public override TitleLoaded(resourceManager: IReadOnlyResourceManager) {
		this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(Scale.W(1100), Scale.H(490))});
		this.titleSpriteAnim.View().style.position = "absolute";
		this.titleSpriteAnim.View().style.bottom="0px";
		this.titleSpriteAnim.View().style.left="0px";
		//this.titleSpriteAnim.Scale(1.1);
		this.TitleContainer.appendChild(this.titleSpriteAnim.View());
	}

}
